import { useMemo } from 'react'
import { useSingleProductGroup } from './use-single-product-group'

export const useShowCommercialName = (product?: { ProductGroups: string[]; CommercialName: string } | null) => {
  const productGroup = useSingleProductGroup(product)
  return useMemo(() => {
    if (!product?.CommercialName) {
      return false
    }
    // check if CommercialName and description are similar, ignoring case and punctuation.
    // we don't want to show duplicate data, so we hide CommercialName when they're equal
    const trimmedCommercialName = (product.CommercialName || '').trim()
    const trimmedDescription = (productGroup || '').trim()
    return trimmedCommercialName.localeCompare(trimmedDescription, undefined, { ignorePunctuation: true, sensitivity: 'base' }) !== 0
  }, [product, productGroup])
}
